function isNumberLike(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        value instanceof String ||
        value instanceof Number);
}
export function toFiniteNumber(value) {
    if (value === undefined) {
        return undefined;
    }
    if (isNumberLike(value)) {
        const converted = Number(value);
        return Number.isFinite(converted) ? converted : undefined;
    }
    return Array.from(value, (entry) => {
        const converted = Number(entry);
        return Number.isFinite(converted) ? converted : undefined;
    });
}
export function toNumber(val) {
    if (val === undefined || val === null) {
        return undefined;
    }
    if (isNumberLike(val)) {
        return Number(val);
    }
    if (Array.isArray(val)) {
        return val.map((entry) => Number(entry));
    }
    if (typeof val === 'object' && Symbol.iterator in val) {
        return Array.from(val, (entry) => Number(entry));
    }
    return Number(val);
}
export default toNumber;
